export { default } from './product-diagram-content';
export { ProductDiagramContent } from './product-diagram-content';